import api from '../../../services/api';

/**
 * Team Service - Handles all API interactions for the Teams module.
 * Strictly uses the central Axios instance from src/services/api.js.
 */
export const teamService = {
  /**
   * Fetches the list of all team members with pagination and filters.
   * @param {Object} params - { page, limit, search, role }
   * @returns {Promise<Object>} API response with data, pagination, and stats.
   */
  getEmployees: async (params = {}) => {
    try {
      const response = await api.get('/teams', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching employees:', error);
      const err = new Error(error.response?.data?.message || error.message || 'Request failed');
      err.data = error.response?.data; // Preserve backend payload (field-specific errors)
      throw err;
    }
  },

  /**
   * Creates a new employee/team member.
   * @param {Object} employeeData - Form data from AddEmployeeModal.
   * @returns {Promise<Object>} Created employee record.
   */
  createEmployee: async (employeeData) => {
    try {
      const response = await api.post('/teams', employeeData);
      return response.data;
    } catch (error) {
      console.error('Error creating employee:', error);
      const err = new Error(error.response?.data?.message || error.message || 'Request failed');
      err.data = error.response?.data;
      throw err;
    }
  },

  updateEmployee: async (id, employeeData) => {
    try {
      const response = await api.put(`/teams/${id}`, employeeData);
      return response.data;
    } catch (error) {
      console.error('Error updating employee:', error);
      const err = new Error(error.response?.data?.message || error.message || 'Request failed');
      err.data = error.response?.data;
      throw err;
    }
  }
};




